export function getRoleLabel(role, t, isOwner = false) {
  if (isOwner) {
    return t('users.roleOwner');
  }
  const map = {
    employee: t('users.roleEmployee'),
    supervisor: t('users.roleSupervisor'),
    admin: t('users.roleAdmin'),
    superadmin: t('users.roleSuperadmin')
  };
  return map[role] || role || '—';
}

export function getStatusLabel(isActive, t) {
  return isActive ? t('users.active') : t('users.inactive');
}
